module.exports = __webpack_public_path__ + "img/DW365-290.39cd9c25.jpg";